export enum CacheTag {
  AppUsers = 'AppUsers',
  AppointmentDetails = 'AppointmentDetails',
  Assessment = 'Assessment',
  AssessmentsList = 'AssessmentsList',
  PatientAppointmentsWithNotes = 'PatientAppointmentsWithNotes',
  BillingPeriods = 'BillingPeriods',
  CandidatePatients = 'CandidatePatients',
  CarePlanForNote = 'CarePlanForNote',
  DischargePlan = 'DischargePlan',
  DischargePlanTasks = 'DischargePlanTasks',
  DuplicateContacts = 'DuplicateContacts',
  EquipScaleOrder = 'EquipScaleOrder',
  GetNote = 'GetNote',
  GetNoteList = 'GetNoteList',
  GroupClassNotesByEventExternalIds = 'GroupClassNotesByEventExternalIds',
  GroupSectionNotesByEventExternalIds = 'GroupSectionNotesByEventExternalIds',
  GroupClassEventConfirmedAttendees = 'GroupClassEventConfirmedAttendees',
  GroupSectionEventConfirmedAttendees = 'GroupSectionEventConfirmedAttendees',
  GroupClassEventDetails = 'GroupClassEventDetails',
  GroupedAssessments = 'GroupedAssessments',
  GroupClassCounts = 'GroupClassCounts',
  GroupCountV2 = 'GroupCountV2',
  GroupHosts = 'GroupHosts',
  GroupDetails = 'GroupDetails',
  GroupClassList = 'GroupClassList',
  GroupSessionDetails = 'GroupSessionDetails',
  GroupClassEvents = 'GroupClassEvents',
  GroupClassEventsV2 = 'GroupClassEventsV2',
  Inquiries = 'Inquiries',
  Inquiry = 'Inquiry',
  MaiMessages = 'MaiMessages',
  MaiPrompts = 'MaiPrompts',
  InquiryReviews = 'InquiryReviews',
  InquiryTasksById = 'InquiryTasksById',
  NoteTemplates = 'NoteTemplates',
  NoteTemplateRevisions = 'NoteTemplateRevisions',
  Observations = 'Observations',
  PatientClinicalProfile = 'PatientClinicalProfile',
  PatientDiagnoses = 'PatientDiagnoses',
  PatientDocuments = 'PatientDocuments',
  PatientContact = 'PatientContact',
  PatientContactById = 'PatientContactById',
  PatientCoveragesById = 'PatientCoveragesById',
  PatientInquiries = 'PatientInquiries',
  PatientInquiryNotes = 'PatientInquiryNotes',
  PatientInquiriesSummary = 'PatientInquiriesSummary',
  PatientNotes = 'PatientNotes',
  PatientTreatmentEpisodes = 'PatientTreatmentEpisodes',
  PatientProviderTeamAssignments = 'PatientProviderTeamAssignments',
  PatientReassignments = 'PatientReassignments',
  ProviderAssignmentRecommendations = 'ProviderAssignmentRecommendations',
  ProfileInfo = 'ProfileInfo',
  ProfileOutOfOffice = 'ProfileOutOfOffice',
  PatientAndSupportGroups = 'PatientAndSupportGroups',
  GetPatientById = 'GetPatientById',
  ProviderProfileAvatar = 'ProviderProfileAvatar',
  TasksFilterById = 'TasksFilterById',
  TaskComments = 'TaskComments',
  TreatmentEpisodes = 'TreatmentEpisodes',
  DiscussionOfWeightAttributes = 'DiscussionOfWeightAttributes',
  FormAttributes = 'FormAttributes',
  LevelAttributes = 'LevelAttributes',
  MedicalStabilityAttributes = 'MedicalStabilityAttributes',
  ModalityAttributes = 'ModalityAttributes',
  PhaseStageAttributes = 'PhaseStageAttributes',
  PsychiatricStabilityAttributes = 'PsychiatricStabilityAttributes',
  RefeedingRiskAttributes = 'RefeedingRiskAttributes',
  SaferStageAttributes = 'SaferStageAttributes',
  LabPatientChart = 'LabPatientChart',
  TreatmentEpisodeAttributes = 'TreatmentEpisodeAttributes',
  CarePlans = 'CarePlans',
  SMTConfigurations = 'SMTConfigurations',
  SMTSummary = 'SMTSummary',
  SMTDailyLogs = 'SMTDailyLogs',
  ProviderDashboard = 'ProviderDashboard',
  ProviderDashboardV2 = 'ProviderDashboardV2',
  SafetyRiskAlerts = 'SafetyRiskAlerts',
  ScriptSureSyncFailures = 'ScriptSureSyncFailures',
}

export type CacheTagWithId = {
  id: string;
  type: CacheTag;
};
